import Template from './ExperienceSelectorCollectionItemView.njk';
import Marionette from "backbone.marionette";
import "./ExperienceSelectorCollectionItemView.less";

export const ExperienceSelectorCollectionItemView = Marionette.View.extend({
  template: Template,
    className: "ExperienceSelectorCollectionItemView col-sm-6",

    triggers: {
        "change :checkbox": "toggle"
    },

    templateContext() {
        var medias = this.model.get("medias");
        return {
            image: medias && medias[0] && medias[0].src ? medias[0].src : "img/gray-square.png",
            selected: this.options.selected
        }
    }
});


// WEBPACK FOOTER //
// ./src/js/view/components/ExperienceSelector/ExperienceSelectorCollectionItemView.js